import React,{Component} from 'react';
import Card,{ CardActions, CardContent, CardMedia } from 'material-ui/Card';
import Button from 'material-ui/Button';
import Divider from 'material-ui/Divider';
import './Blog.css'
import { getJSON } from 'jquery'
import Cookies from 'js-cookie'

class SimpleBlogCard extends Component{
constructor(){
    super();
    this.state={
        login:this.isLogin()
    }
}


    isLogin(){
        if (Cookies.get('user')==null){
            return false
        }else{

            return true
        }
    }


    handleClick(id,event){
        getJSON('http://123.207.90.121:8080/newBlog/api/deleteBlog',{id:id}).then(response=>{

    return true
        },error=> {

        }).then((flag)=>{
            this.props.handleCache()
        })
    }
    render(){



        return  (

                <Card style={{width:'100%',background: 'white'}}>
                    <CardMedia
                        style={{height:'150px'}}
                        className='doudun'
                        image={this.props.imageUrl}
                        title={this.props.title}
                    >
                        <Button style={{backgroundColor:'#fffdf4',fontSize:'10px',width:'40px',height:'40px',position:'relative',right:'-80%',bottom:'-90%'}} variant="fab" aria-label="edit" >
                            <span style={{fontStyle:'normal'}}>{this.props.type.substring(0,4)}</span>
                        </Button>
                    </CardMedia>
                    <CardContent    style={{height:'150px',overflow: 'hidden'}}>

                        <h4 style={{marginTop:'5px',marginBottom:'5px',color:'#0f0f0f',wordBreak:'break-all',fontWeight:'lighter'}}>
                            {this.props.title}
                        </h4>

                        <p style={{marginTop:'5px',marginBottom:'5px',color:'#685b4f',fontSize:'10px'}}>
                            {this.props.signal}
                        </p>
                    </CardContent>
                    <Divider/>
                    <CardActions>

                        <Button size="small" color="primary" onClick={this.props.handleView}>
                            VIEW
                        </Button>
                        {this.state.login?
                        < Button size="small" color="primary" onClick={this.handleClick.bind(this,this.props.id)}>
                            DELETE
                            </Button>
                            :''
                        }

                        <table ><tbody><tr><td align="right" style={{fontSize:'12px',color:'green'}}>
                          {this.props.time.substring(0,10)}
                        </td></tr></tbody></table>
                    </CardActions>
                </Card>

        );
    }
}


export default SimpleBlogCard;


// WEBPACK FOOTER //
// ./src/Compent/page/SimpleBlogCard.js